import { createContext } from 'react'

export const LoginContext = createContext({
  phonenumber: '',
  setphonenumber: () => {},
  loginForm: true,
  setLoginForm: () => {},
  otp: false,
  setotp: () => {}
})
